import TopNav from "@/components/TopNav";
import Footer from "@/components/Footer";

export default function Layout({ children, withFooter = true, withNav = true }) {
  return (
    <div className="min-h-screen flex flex-col bg-bone text-ink">
      {withNav && <TopNav />}
      <main className="flex-1">{children}</main>
      {withFooter && <Footer />}
    </div>
  );
}
